import { motion } from 'framer-motion';

const VfxOverlay = () => {
    return (
        <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
            {/* Top Right Light Leak */}
            <motion.div
                className="absolute -top-1/2 -right-1/4 w-[100%] h-[100%] rounded-full bg-primary-100/20 blur-[120px] animate-light-leak"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 2 }}
            />

            {/* Bottom Left Light Leak */}
            <motion.div
                className="absolute -bottom-1/2 -left-1/4 w-[80%] h-[80%] rounded-full bg-blue-50/30 blur-[100px] animate-light-leak"
                style={{ animationDelay: '-5s' }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 2, delay: 1 }}
            />

            {/* Subtle Bokeh Particles */}
            <div className="absolute inset-0">
                {[...Array(6)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute w-2 h-2 bg-primary-200/20 rounded-full blur-[1px]"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                        }}
                        animate={{
                            y: [0, -20, 0],
                            x: [0, 10, 0],
                            opacity: [0.1, 0.3, 0.1],
                        }}
                        transition={{
                            duration: 5 + Math.random() * 5,
                            repeat: Infinity,
                            delay: Math.random() * 5,
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default VfxOverlay;
